import { atom } from "recoil";

const ordersState = atom({
    key: "ordersState",
    default: undefined,
});

export { ordersState };